import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Link, Typography } from '@dxb-web-ui-framework/design-system';
import { Close as CloseIcon } from '@material-ui/icons';
import { APP_LANDING_PAGE } from '../../../../utils';

type MobileHeaderContentProps = {
  isWebView: Boolean;
  logo?: any;
  logoAlt?: string;
};

const MobileHeaderContent: FC<MobileHeaderContentProps> = ({ isWebView, logo, logoAlt }) => {
  const { t } = useTranslation();

  const onClickCloseButton = () => {
    window.location.href = APP_LANDING_PAGE;
  };

  return isWebView ? (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
      <Box>
        <Button
          aria-label={t('screenSplitLayout.MobileHeader.CloseButton.AriaLabel')}
          isIconButton
          onClick={onClickCloseButton}
          color='secondary'
          size='small'
          title={t('screenSplitLayout.MobileHeader.CloseButton.Title')}
          variant='text'
          data-testid='close-mobile-header-button'>
          <CloseIcon />
        </Button>
      </Box>
      <Typography variant={'h5'} component={'h1'}>
        <Link
          component={'a'}
          href={APP_LANDING_PAGE}
          title={t('screenSplitLayout.Header.Logo.Title')}
          aria-label={t('screenSplitLayout.Header.Logo.AriaLabel')}>
          <img src={logo} alt={t('screenSplitLayout.Header.Logo.ImgAlt')} height={32} width={75} aria-hidden={true} />
          <Typography variant={'srOnly'}>{logoAlt}</Typography>
        </Link>
      </Typography>
    </Box>
  ) : (
    <Box display={'flex'} flexDirection={'row'} width={'100%'}>
      <Typography variant={'h5'} component={'h1'}>
        <Link
          component={RouterLink}
          to={'/'}
          title={t('screenSplitLayout.Header.Logo.Title')}
          aria-label={t('screenSplitLayout.Header.Logo.AriaLabel')}>
          <img src={logo} alt={t('screenSplitLayout.Header.Logo.ImgAlt')} height={36} aria-hidden={true} />
          <Typography variant={'srOnly'}>{logoAlt}</Typography>
        </Link>
      </Typography>
    </Box>
  );
};

export { MobileHeaderContent };
